import { OptOutItem } from './types';

/**
 * Formats the opt-out type for display
 */
export const formatOptOutType = (type: OptOutItem['dnc_type']): string => {
  switch (type) {
    case 'PHONE':
      return 'Phone';
    case 'STATE':
      return 'State';
    case 'AREA-CODE':
      return 'Area Code';
    default:
      return type;
  }
};

/**
 * Gets the badge class for opt-out type
 */
export const getOptOutTypeBadgeClass = (type: OptOutItem['dnc_type']): string => {
  switch (type) {
    case 'PHONE':
      return 'bg-blue-100 text-blue-700 border-blue-300';
    case 'STATE':
      return 'bg-yellow-100 text-yellow-700 border-yellow-300';
    case 'AREA-CODE':
      return 'bg-purple-100 text-purple-700 border-purple-300';
    default:
      return 'bg-gray-100 text-gray-700 border-gray-300';
  }
};

/**
 * Validates a phone number for opt-out
 */
export const validatePhoneNumber = (phone: string): boolean => {
  // Remove any non-digit characters
  const digits = phone.replace(/\D/g, '');

  // Should be 10 digits for US phone numbers
  return digits.length === 10;
};

/**
 * Validates an area code for opt-out
 */
export const validateAreaCode = (areaCode: string): boolean => {
  // Remove any non-digit characters
  const digits = areaCode.replace(/\D/g, '');

  // Should be exactly 3 digits
  return digits.length === 3;
};

/**
 * Formats a phone number for display
 */
export const formatPhoneNumber = (phone: string): string => {
  const digits = phone.replace(/\D/g, '');

  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  return phone; // Return as-is if not 10 digits
};

/**
 * Formats an area code for display
 */
export const formatAreaCode = (areaCode: string): string => {
  const digits = areaCode.replace(/\D/g, '');

  if (digits.length === 3) {
    return `(${digits})`;
  }

  return areaCode; // Return as-is if not 3 digits
};
